var cov_p57jktuuy = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Cascader/index.ts",
      hash = "7cbac41150cc054bb03b29f458d3d32a601ac66d",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Cascader/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 10,
          column: 17
        },
        end: {
          line: 15,
          column: 12
        }
      },
      "1": {
        start: {
          line: 17,
          column: 0
        },
        end: {
          line: 17,
          column: 41
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0,
      "1": 0
    },
    f: {},
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import Component from './Cascader';
import inputable from '../Form/inputable';
import inputBorder from '../hoc/inputBorder';
import { selectClass } from '../Select/styles';
import { compose } from '../utils/func';
import filter from './filter';
import absolute from '../Table/context';
var Cascader = (cov_p57jktuuy.s[0]++, compose(inputable, inputBorder({
  className: selectClass('_'),
  tag: 'span'
}), filter, absolute)(Component));
cov_p57jktuuy.s[1]++;
Cascader.displayName = 'ShineoutCascader';
export default Cascader;